import { getValueCookie } from "../services/cookieService"

// Document number prefixes (XX#####) by company.
// CompanyId 6 = Altitude, anything else = Mayaland (same fallback the old 'AL' : 'PM' logic used).
const PREFIXES = {
    '6': { SalesOrder: 'AS', Invoice: 'AI' },
    default: { SalesOrder: 'MS', Invoice: 'MI' }
}

// Prefixes used before the MS/MI/AS/AI change. Kept so existing documents are still recognized.
export const LEGACY_SALES_ORDER_PREFIXES = ['PM', 'AL']
export const LEGACY_INVOICE_PREFIXES = ['PM']

function getCompanyPrefixes(companyId = getValueCookie('CompanyId')) {
    return PREFIXES[String(companyId)] || PREFIXES.default
}

export function getSalesOrderPrefix(companyId) {
    return getCompanyPrefixes(companyId).SalesOrder
}

export function getInvoicePrefix(companyId) {
    return getCompanyPrefixes(companyId).Invoice
}

// Correlatives are padded to 5 digits so numbers keep the XX##### format (1 -> 00001).
const CORRELATIVE_DIGITS = 5

function padCorrelative(correlative) {
    return String(correlative).padStart(CORRELATIVE_DIGITS, '0')
}

export function buildSalesOrderNo(correlative, companyId) {
    return getSalesOrderPrefix(companyId) + padCorrelative(correlative)
}

export function buildInvoiceNo(correlative, companyId) {
    return getInvoicePrefix(companyId) + padCorrelative(correlative)
}

// True when the Sales Order number belongs to Altitude (new AS or legacy AL).
export function isAltitudeSalesOrder(orderNo) {
    return /^(AS|AL)/.test(String(orderNo || ''))
}

// Removes a leading invoice prefix (new MI/AI or legacy PM) and returns only the number part.
export function stripInvoicePrefix(invoiceNo) {
    return String(invoiceNo || '').replace(/^(MI|AI|PM)/, '')
}

export default { getSalesOrderPrefix, getInvoicePrefix, buildSalesOrderNo, buildInvoiceNo, isAltitudeSalesOrder, stripInvoicePrefix }
